"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BackgroundCheckedPopover = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _Popover = _interopRequireDefault(require("angieslist-react-components/lib/Popover"));

var _angieslistStyles = require("angieslist-styles");

var _p;

var BackgroundCheckedPopover = function BackgroundCheckedPopover(props) {
  return /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
    id: "popover-background-checked-badge"
  }, props, {
    style: {
      minWidth: 305
    }
  }), /*#__PURE__*/(0, _jsx2.default)("p", {
    style: {
      marginTop: 10
    }
  }, void 0, /*#__PURE__*/(0, _jsx2.default)("strong", {
    style: {
      color: _angieslistStyles.stylesColors.green
    }
  }, void 0, "Angie's List Background Checked")), _p || (_p = /*#__PURE__*/(0, _jsx2.default)("p", {}, void 0, "An owner or relevant manager of this business passed a criminal background check.")));
};

exports.BackgroundCheckedPopover = BackgroundCheckedPopover;
var _default = BackgroundCheckedPopover;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/backgroundCheckedPopover/BackgroundCheckedPopover.js
// module id = 3290
// module chunks = 25